import * as React from "react";
import type { SVGProps } from "react";
const SvgRefundRecipe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.75 10 6.665 7.918l2.083-2.083"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11.812 17.376-1.4-.934a.74.74 0 0 0-.822 0l-1.401.934a.74.74 0 0 1-.822 0l-1.4-.934a.74.74 0 0 0-.821 0l-.66.44a.74.74 0 0 1-1.152-.616V3.982c0-.819.663-1.482 1.482-1.482h10.37c.818 0 1.481.663 1.481 1.482v12.284c0 .592-.659.944-1.151.617l-.66-.44a.74.74 0 0 0-.822 0l-1.4.933a.74.74 0 0 1-.822 0"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.666 7.916h4.375a2.29 2.29 0 0 1 2.292 2.292v0a2.29 2.29 0 0 1-2.292 2.291H9.999"
    />
  </svg>
);
export default SvgRefundRecipe;
